import { gridGutter, gridGutterJobSearch } from '../../../styles/grid';

/**
 * @param {number | undefined} [gutter]
 * @param {boolean | undefined} [isJobSearch]
 * @returns {number}
 */
function getGutter(gutter, isJobSearch) {
  if (gutter) return gutter;
  return isJobSearch ? gridGutterJobSearch : gridGutter;
}

export default getGutter;
